import { MatchMachine } from "../util/match-machine";
import { matchMimeTypeTo3xPngUrl, matchMimeTypeToPngUrl, matchMimeTypeToUrl } from "../util/const";
import { iconUrl as iconsUrlMap, iconPngUrl as iconPngUrlMap, iconPng3xUrl } from "../util/icons";
import { FileIconFormat } from "../lib/file-icon-url";
var matchSvgMachine = new MatchMachine(iconsUrlMap, matchMimeTypeToUrl);
var matchPngMachine = new MatchMachine(iconPngUrlMap, matchMimeTypeToPngUrl);
var matchPng3xMachine = new MatchMachine(iconPng3xUrl, matchMimeTypeTo3xPngUrl);
export var getDeviceMachine = function getDeviceMachine(size, format) {
  if (format === FileIconFormat.SVG) {
    return matchSvgMachine;
  }
  // node下则默认是1
  var devicePixelRatio = typeof window !== 'undefined' && window.devicePixelRatio || 1;
  // 72是 3x格式的png图片最大尺寸
  if (size * devicePixelRatio <= 72) {
    return matchPng3xMachine;
  }
  return matchPngMachine;
};
//# sourceMappingURL=device-machine.js.map